import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, closeCollapsible } from '../../../utils/util';
import BackButton from '../../../components/UI/BackButton';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { InfiniteScroll, Collapsible, Input, Button } from '../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../utils/handleChangeHooks';

const PartNumberOut = (props) => {
    const [data, setData] = useState([]);
    const [dataPaged, setDataPaged] = useState();
    const [filter, setFilter] = useState({
        mvmNumber: '',
        notFinished: true,
        partNumber: '',
        pending: true,
        createdOnStart: '',
        createdOnEnd: ''
    })
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        if (currentPage > 0) {
            onClickButton(false);
        }
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        if (dataPaged?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(dataPaged.items);
            } else {
                setData((prevState) => ([...prevState, ...dataPaged.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [dataPaged?.items]);

    useEffect(() => {
        onClickButton(false);
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onClickButton = (click) => {
        var currentPageList = currentPage;
        if (click) {
            currentPageList = 0;
            setCurrentPage(0);
            setData([]);
        }

        props.getPartNumbers({
            ...filter,
            pageSize: 12,
            PageIndex: currentPageList
        }, (response) => {
            if (click) {
                closeCollapsible("collapsible2");
            }
            setDataPaged(response)
        });
    }

    const renderItem = (item, index) => {
        return (
            <div
                style={{ display: 'block', padding: '10px', height: 'auto' }}
                key={`oi-${index}`}
            >
                <div className="row" style={{ marginBottom: '0px' }}>

                    <div className="col s12" style={{ color: 'black' }}>
                        {item?.partNumberCode}
                    </div>
                    <div className="col s12" style={{ color: 'black' }}>
                        {item?.partNumberDescription}
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:mvm')}: ${(item.mvmNumber) ? item.mvmNumber : 'N/A'}`}</label>
                    </div>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:journey')}: ${(item.journey) ? item.journey : 'N/A'}`}</label>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:shed')}: ${(item.shed) ? item.shed : 'N/A'}`}</label>
                    </div>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:quantity')}: ${(item.accoutingQuantity) ? item.accoutingQuantity : 'N/A'}`}</label>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:invoice')}: ${(item.invoice) ? item.invoice : 'N/A'}`}</label>
                    </div>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:qt-receipt')}: ${item.accoutingQuantity - item.balance || 0}`}</label>
                    </div>
                    <div className="col s6">
                        <label>{` ${translate('physical-confirmation:plate')}: ${(item.plate) ? item.plate : 'N/A'}`}</label>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65" />
            <div className="container" style={{ marginTop: '0px' }}>
                <Collapsible
                    id="collapsible2"
                    header={translate('expedition:picking.filter')}
                    body={
                        <>
                            <div id="formsReport" className="row">
                                <div className="input-field no-padding col s5">
                                    <Input
                                        defaultValue={filter.createdOnStart}
                                        type="date"
                                        label={translate('change-location:startDate')}
                                        id="createdOnStart"
                                        name="createdOnStart"
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        defaultValue={filter.createdOnEnd}
                                        type="date"
                                        label={translate('change-location:startDate')}
                                        id="createdOnEnd"
                                        name="createdOnEnd"
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="partNumber"
                                        name='partNumber'
                                        label={translate('physical-confirmation:part-number')}
                                        type="text"
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="journey"
                                        name='journey'
                                        label={translate('physical-confirmation:journey')}
                                        type="text"
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <Button onClick={() => onClickButton(true)} full="true" text={translate('delivery:general.search')} />
                            </div>
                        </>
                    }
                />
            </div>
            <div className="container-fluid" style={{ marginTop: '5px', paddingBlockEnd: '50px' }}>
                <div id="listpartNumbers">
                    <InfiniteScroll
                        page={dataPaged?.totalPages}
                        hasMore={currentPage < dataPaged?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            data.map((item, index) => {
                                return renderItem(item, index);
                            })
                        }
                    />
                </div>
            </div>

        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPartNumbers: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getReceiptPaged(filter, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PartNumberOut));